export const CART_MOVE_TO_SAVEFORLATER_REQUEST = "CART_MOVE_TO_SAVEFORLATER_REQUEST";
export const CART_MOVE_TO_SAVEFORLATER_SUCCESS = "CART_MOVE_TO_SAVEFORLATER_SUCCESS";
export const CART_MOVE_TO_SAVEFORLATER_FAIL = "CART_MOVE_TO_SAVEFORLATER_FAIL";

export const CART_MOVE_TO_CART_REQUEST = "CART_MOVE_TO_CART_REQUEST";
export const CART_MOVE_TO_CART_SUCCESS = "CART_MOVE_TO_CART_SUCCESS";
export const CART_MOVE_TO_CART_FAIL = "CART_MOVE_TO_CART_FAIL";

export const GET_SAVE_FOR_LATER_ITEMS_REQUEST = "GET_SAVE_FOR_LATER_ITEMS_REQUEST";
export const GET_SAVE_FOR_LATER_ITEMS_SUCCESS = "GET_SAVE_FOR_LATER_ITEMS_SUCCESS";
export const GET_SAVE_FOR_LATER_ITEMS_FAILURE = "GET_SAVE_FOR_LATER_ITEMS_FAILURE";